import { render, staticRenderFns } from "./DeclaredContainerDetails.vue?vue&type=template&id=02324734&scoped=true"
import script from "./DeclaredContainerDetails.vue?vue&type=script&lang=ts"
export * from "./DeclaredContainerDetails.vue?vue&type=script&lang=ts"
import style0 from "./DeclaredContainerDetails.vue?vue&type=style&index=0&id=02324734&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02324734",
  null
  
)

export default component.exports